export const deAgency = {
	agency: {
		// leave file for reference
	}
};
